// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SpecimenSamplesSettingsForm__wrapper__3i5Oa","submitResult":"SpecimenSamplesSettingsForm__submitResult__3iR6m","actionWrapper":"SpecimenSamplesSettingsForm__actionWrapper__2C1FJ","wrapper2faOptions":"SpecimenSamplesSettingsForm__wrapper2faOptions__i1ZmP"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/SpecimenSamplesSettings/SpecimenSamplesSettingsForm.css
// module id = 3266
// module chunks = 0